import { Field, FieldArray, useField } from "formik";
import React, { useState } from "react";
import BaseElement from "components/FormElements/BaseElement";
import ContentPicker from "components/DesignSystem/ContentPicker";
import SecondaryButton from "components/Buttons/SecondaryButton";
import ContentDescription from "components/DesignSystem/ContentDescription";
import { TrashIcon } from "@heroicons/react/solid";

export default function RelatedcontentMetaProperty(props) {
    const [field, meta] = useField(props);
    const [pickerOpen, setPickerOpen] = useState(false);

    const handleMediaSelect = (media, arrayHelpers) => {
        console.log("selected", media);
        if (!media) {
            return;
        }
        media.map((i) => arrayHelpers.push(i.uuid));
    };

    const input = (
        <div>
            <FieldArray
                name={field.name}
                render={(arrayHelpers) => (
                    <div className="space-y-4">
                        {field.value
                            ? field.value.map((val, idx) => (
                                  <div key={idx}>
                                      <Field
                                          name={field.name + "" + idx}
                                          value={val}
                                          className="hidden"
                                      />
                                      <div className="flex items-center space-x-4">
                                          <button
                                              type="button"
                                              onClick={() => {
                                                  if (props.disabled) {
                                                      return;
                                                  }

                                                  return arrayHelpers.remove(
                                                      idx
                                                  );
                                              }}
                                          >
                                              <TrashIcon className="h-5 w-5" />
                                          </button>
                                          <div className="flex-grow">
                                              <ContentDescription
                                                  uuid={val}
                                                  loadOnDemand={true}
                                              />
                                          </div>
                                      </div>
                                  </div>
                              ))
                            : null}
                        <ContentPicker
                            open={pickerOpen}
                            onRequestClose={() => {
                                setPickerOpen(false);
                            }}
                            onSelect={(media) => {
                                handleMediaSelect(media, arrayHelpers);
                            }}
                            allowMultiple={true}
                            listType="list"
                        />
                        <SecondaryButton
                            onClick={() => setPickerOpen(true)}
                            label="Select Content"
                        />
                    </div>
                )}
            />
        </div>
    );

    const label = (
        <label
            htmlFor={props.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const helperText = props.helpertext ? (
        <p className="mt-2 text-sm text-gray-500">{props.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        props.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {props.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...props}
            input={input}
            label={label}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}

export const Property = RelatedcontentMetaProperty;

export const Label = "Content Select";
